import { PLAYER_URL_SOURCES } from './constants';
import type { TKeys } from './i18n';

export interface IAppProps {
  pageUrl?: string;
}

export type UserDashboardLocaleKeys = TKeys;

export type UserDashboardPlayerUrlSource =
  (typeof PLAYER_URL_SOURCES)[keyof typeof PLAYER_URL_SOURCES];

export type FaqType = {
  key: string;
  href: string;
  text: UserDashboardLocaleKeys;
};

export enum StudentTypeEnum {
  PAYG = 'payg',
  B2B = 'b2b',
  DEGREE = 'degree',
  PREMIUM = 'premium',
  PREMIUM_TRIAL = 'premium-trial',
  REGISTER = 'register',
}

export type StudentType =
  | 'degree'
  | 'b2b'
  | 'premium'
  | 'premium-trial'
  | 'register'
  | 'payg';
